<template>
    <div>
        <!-- Thumbnails + File List -->
        <div class="row g-3">
            <div
                v-for="(file, index) in files"
                :key="file.id"
                class="col-6 col-md-4 mb-4"
            >
                <!-- Image thumbnail -->
                <img
                    v-if="isImage(file.file_name)"
                    :src="file.url"
                    class="img-fluid rounded shadow-sm gallery-thumb"
                    style="height:120px; width:100%; object-fit:cover; cursor:pointer;"
                    :alt="file.file_name"
                    @click="openLightbox(index)"
                />

                <!-- Non-image file -->
                <a
                    v-else
                    :href="file.url"
                    :download="file.file_name"
                    class="d-flex align-items-center justify-content-center border rounded p-2 text-decoration-none"
                    style="height:120px;"
                >
                    <i class="bi bi-download fs-4 me-2"></i>
                    <span class="text-truncate">{{ file.file_name }}</span>
                </a>
            </div>
        </div>

        <!-- Lightbox -->
        <div v-if="lightboxOpen" class="lightbox" @click.self="closeLightbox">
            <button class="lightbox-close" @click="closeLightbox">&times;</button>

            <button
                v-if="imageFiles.length > 1"
                class="lightbox-nav prev"
                @click.stop="prevImage"
            >
                &lsaquo;
            </button>

            <img
                :src="imageFiles[currentIndex].url"
                class="lightbox-image"
                :alt="imageFiles[currentIndex].file_name"
            />

            <button
                v-if="imageFiles.length > 1"
                class="lightbox-nav next"
                @click.stop="nextImage"
            >
                &rsaquo;
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LightboxGallery",
        props: {
            files: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                lightboxOpen: false,
                currentIndex: 0,
            };
        },
        computed: {
            imageFiles() {
                return this.files.filter((file) => this.isImage(file.file_name));
            },
        },
        methods: {
            openLightbox(index) {
                this.currentIndex = index;
                this.lightboxOpen = true;
                document.addEventListener("keydown", this.handleKeydown);
            },
            closeLightbox() {
                this.lightboxOpen = false;
                document.removeEventListener("keydown", this.handleKeydown);
            },
            nextImage() {
                this.currentIndex = (this.currentIndex + 1) % this.imageFiles.length;
            },
            prevImage() {
                this.currentIndex =
                    (this.currentIndex - 1 + this.imageFiles.length) % this.imageFiles.length;
            },
            handleKeydown(e) {
                if (!this.lightboxOpen) return;
                if (e.key === "Escape") this.closeLightbox();
                if (e.key === "ArrowRight") this.nextImage();
                if (e.key === "ArrowLeft") this.prevImage();
            },
            isImage(fileName) {
                if (!fileName){ 
                    return false;
                }
                const ext = fileName.split(".").pop().toLowerCase();
                return ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg"].includes(ext);
            },
        },
    };
</script>

<style scoped>
    .lightbox {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.85);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1050;
    }

    .lightbox-image {
        max-width: 90%;
        max-height: 90%;
    }

    .lightbox-close {
        position: absolute;
        top: 20px;
        right: 25px;
        font-size: 36px;
        color: #fff;
        background: none;
        border: 0;
        cursor: pointer;
    }

    .lightbox-nav {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        font-size: 60px;
        color: #fff;
        background: none;
        border: 0;
        cursor: pointer;
        padding: 0 15px;
    }

    .lightbox-nav.prev {
        left: 10px;
    }

    .lightbox-nav.next {
        right: 10px;
    }
</style>
